import { HOSTSERVERPATH } from "@/config/config";

export const HOSTSERVER = HOSTSERVERPATH;

export const VALOR_NUMERICO_TRUE = 1;

export const PORCION_PROGRESO = 20;

export const Rol = {
  ADMINISTRADOR: 1,
  VENTAS: 3
};


export const RegistroClaveSol = {
  CAPTURA: 1,
  CLAVE: 2,
  OMITIR: 3
};

export const RegistroSerie = {
  SI: 1,
  NO: 2
};

export const TabsRegistro = {
  INICIAL: 0,
  DATOS_EMPRESA: 1,
  SUCURSALES: 2,
  CONTACTO: 3,
  CLAVE_SOL: 4,
  LOGO: 5,
  SERIES: 6,
  FINAL: 7
};

export const EstadoRegistro = {
  ACTIVO: 1,
  INACTIVO: 0
};

export const PaginacionDefault = {
  FILTRO: '',
  PAGINA: 0,
  SIZE: 1000,
  ESTADO: EstadoRegistro.ACTIVO
};

export const PAQUETE = [
  {label: 'Micro.', value : 1},
  {label: 'Estandar', value : 2},
  {label: 'Base', value : 3},
  {label: 'Plus', value : 4},
  {label: 'Ilimitado', value : 5},
  {label: 'Gratuito', value : 6},
  {label: 'Personalizado', value : 7},
  {label: 'Socio', value : 8},
  {label: 'Nuevo Plan 49', value : 9},
  {label: 'Nuevo Plan 79', value : 10},
  {label: 'Nuevo Plan 96', value : 11},
  {label: 'Nuevo Plan 129', value : 12},
  {label: 'Nuevo Plan 99', value : 13},
  {label: 'Nuevo Plan 39', value : 14},
  {label: 'Nuevo Plan 69', value : 15}

];
export const DOCS = [
  {label: 'No tiene', value : 1},
  {label: 'Incluye el paquete', value : 2},
  {label: 'Ilimitado', value : 3}
];
export const ESTADOS = [
  {label: 'Contrato', value : 1},
  {label: 'Registro', value : 2}
];
export const TIPO_PLAN = [
  {label: 'Mensual', value : 1},
  {label: 'Semestral', value : 2},
  {label: 'Anual', value : 3},
  {label: '2 años', value : 4},
  {label: '3 años', value : 5},
  {label: 'Pago único', value : 6},
  {label: 'Trimestral', value : 7}
];
export const ROLES = [
  {label: 'Administrador', value : 1},
  {label: 'Asesor', value : 2},
  {label: 'Ventas', value : 3}
];
export const OCUPACIONES = [
  {label: 'Estudiante Universitario', value : 1},
  {label: 'Negocio de venta de equipos', value : 2},
  {label: 'Proveedor de servicios tecnológicos', value : 3},
  {label: 'Proveedor de líneas de internet', value : 4},
  {label: 'Emprendedor', value : 5},
  {label: 'Consultor', value : 6},
  {label: 'Otros', value : 7}
];

export const EstadoContador = {
  PENDIENTE: 1,
  REGISTRADO: 2,
  CANCELADO: 3
};
export const RegistroEstadoContador = {
  PENDIENTE: 1,
  CONFIRMADO: 2
};

export const ESTADO_CONTADOR = [
  {descripcion: 'Pendiente', id : EstadoContador.PENDIENTE, abreviacion: 'P'},
  {descripcion: 'Registrado', id : EstadoContador.REGISTRADO, abreviacion: 'R'},
  {descripcion: 'Cancelado', id : EstadoContador.CANCELADO, abreviacion: 'C'},
];
export const ESTADO_REGISTRO_CONTADOR = [
  {descripcion: 'Pendiente', id : RegistroEstadoContador.PENDIENTE, abreviacion: 'P'},
  {descripcion: 'Confirmado', id : RegistroEstadoContador.CONFIRMADO, abreviacion: 'C'}
];



/**INICIALIZACIONES*/
export const ContratoCreateInit = {
  asesor: -1,
  direccion: null,
  paquete: -1,        
  sucursales: null,
  usuarios: null,
  numComprobantes: null,
  doc: -1,
  docInternos: null,
  plan: -1,
  costoPlan: null,
  costoMensual: null,
  costoInscripcion: null,
  inicioPromo: null,
  finPromo: null,
  inicioFacturacion: null,
  sinPromocion: null,
  observaciones: null,
  file: null
};
